module.exports = __webpack_public_path__ + "img/2d.0c41627c.png";